package com.devi3east.bashbuddy.features.common.data.models

import com.devi3east.bashbuddy.features.common.data.models.RecipeApiItem
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class RecipeListApiResponse(
    @SerialName("meals")
    val meals: List<RecipeApiItem>
)